import {createContext} from 'react';
import {AccountScoreCustomizeItem} from 'api';

export const CustomizeItemContext =
  createContext<AccountScoreCustomizeItem>(null);
